




























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FooterComponent extends Vue {
  @Prop({default: false}) public readonly isHome!: boolean;
}
